import { IconButton, Paper, TextField } from '@mui/material';
import { FC } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IAsset2Image } from 'src/models';

interface Props {
  data: IAsset2Image[];
  disabled?: boolean;
  setData: (data: IAsset2Image[]) => void;
}

export const ImageViewList: FC<Props> = ({ data, disabled, setData }) => {
  return (
    <div>
      {data.map((fileData, index) => {
        return (
          <div style={{ padding: '12px 0' }} key={index}>
            <Paper key={index} sx={{ padding: '12px' }}>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingBottom: '12px',
                }}
              >
                <TextField
                  disabled={disabled}
                  placeholder="Filename"
                  value={fileData.name}
                  size="small"
                  onChange={(event) => {
                    const newData = [...data];
                    newData[index].name = event.target.value;
                    setData(newData);
                  }}
                />

                <IconButton onClick={() => setData(data.filter((item, i) => i !== index))} disabled={disabled}>
                  <DeleteOutlineIcon sx={{ color: 'grey' }} />
                </IconButton>
              </div>

              <img
                key={index}
                src={fileData.src}
                alt={fileData.name}
                style={{
                  minWidth: '150px',
                  minHeight: '100px',
                  maxWidth: '50%',
                }}
              />
            </Paper>
          </div>
        );
      })}
    </div>
  );
};
